import React, { useEffect } from "react";
import { Modal, Form, Select } from "antd";

const CurricularCalendarFormModal = ({
  visible,
  onCancel,
  onSave,
  loading,
  academicYears = [],
  terms = [],
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) form.resetFields();
  }, [visible, form]);

  async function handleOk() {
    const values = await form.validateFields();
    onSave(values);
  }

  return (
    <Modal
      title="Create Co-Curricular Calendar"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      okText="Create"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="acadyrID"
          label="Academic Year"
          rules={[{ required: true, message: "Select an academic year" }]}
        >
          <Select
            placeholder="Select academic year"
            options={academicYears.map((y) => ({
              value: y.id,
              label: y.acadyr,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="termID"
          label="Term"
          rules={[{ required: true, message: "Select a term" }]}
        >
          <Select
            placeholder="Select term"
            options={terms.map((t) => ({ value: t.id, label: t.name }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CurricularCalendarFormModal;
